export function normalizeConnectedLaneMode(rawLaneAutomation) {
  const mode = String(rawLaneAutomation?.connected || '').toLowerCase();
  return mode === 'semi' ? 'semi' : 'manual';
}
